import { render, staticRenderFns } from "./levyDetail.vue?vue&type=template&id=644bc9cd&scoped=true"
import script from "./levyDetail.vue?vue&type=script&lang=ts"
export * from "./levyDetail.vue?vue&type=script&lang=ts"
import style0 from "./levyDetail.vue?vue&type=style&index=0&id=644bc9cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644bc9cd",
  null
  
)

export default component.exports